import { Button, Card, Col, Form } from "react-bootstrap";
import { ButtonRemover, ButtonTrash, JRow, JTable, JTBody, JTHead } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { infUnidCargaVaziaInteface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import { addUnidadeCargaVazia, removeUnidadeCargaVazia, removeUnidadeCargaVaziaTodos } from "../../../features/manifestoSlice";
import { TypeUnidadesCargaVazia } from "../../../lists";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";

const initialState: infUnidCargaVaziaInteface = {
    id: 0,
    idunidcargavazia: '',
    tpunidcargavazia: '1'
}

export default function UnidadeCargaVazia() {
    const [selecionado, setSelecionado] = useState<number | string>('');
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infUnidCargaVazia);
    const [form, setForm] = useState<infUnidCargaVaziaInteface>(initialState);
    const idUnidadeRef = useRef<HTMLInputElement>(null)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const { confirm, ConfirmModal } = useQuestion();

    const validaPreenchimento = () => {
        if (form.idunidcargavazia.toString() === "") {
            goToFocus(idUnidadeRef);
            alertModal('Informe a Identificação');
            return false;
        }

        if (lista.find((item: infUnidCargaVaziaInteface) =>
            item.idunidcargavazia.trim() === form.idunidcargavazia.trim() &&
            item.tpunidcargavazia === form.tpunidcargavazia)) {
            alertModal('Identificação já adicionado para o tipo de unidade informado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addUnidadeCargaVazia({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(idUnidadeRef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        
        const confirmed = await confirm({
            message: <>Deseja realmente remover Identificação: <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeUnidadeCargaVazia(value.id));
        }
        setSelecionado('')
    }

    const handleRemoverTodos = async () => {
        if (lista.length > 0) {
            
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeUnidadeCargaVaziaTodos());
            }
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>Informações das unidades de carga vazia <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={3}>
                        <Form.Group controlId="aquav-ucv-idunidcargavazia">
                            <Form.Label>* Identificação</Form.Label>
                            <Form.Control type="text" name="idunidcargavazia"
                                title="Identificador da carga"
                                maxLength={20} ref={idUnidadeRef}
                                value={form.idunidcargavazia}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="aquav-ucv-tpunidcargavazia">
                            <Form.Label>* Tipo Unidade</Form.Label>
                            <Form.Select name="tpunidcargavazia" value={form.tpunidcargavazia}
                                onChange={handleChange}
                            >
                                {TypeUnidadesCargaVazia.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button title="Adicionar" variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </Col>
                </JRow>

                <JTable>
                    <JTHead >
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>
                                <ButtonTrash onClick={() => handleRemoverTodos()} />
                            </th>
                            <th className="text-center">Identificação</th>
                            <th className="text-center" >Tipo Unidade</th>
                        </tr>
                    </JTHead>

                    <JTBody>
                        {lista?.map((item: infUnidCargaVaziaInteface) => (
                            <tr key={item.id}
                                className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                <td className="text-center">
                                    <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.idunidcargavazia })} />
                                </td>
                                <td className="text-center">{item.idunidcargavazia}</td>
                                <td className="text-center">{TypeUnidadesCargaVazia.find(t =>
                                    t.id === item.tpunidcargavazia.toString().trim())?.name}
                                </td>

                            </tr>
                        ))}
                    </JTBody>
                </JTable>

            </Card.Body>
        </Card>
        {ModalMessageEl}
        {ConfirmModal}
    </>)
}